import { useMemo } from "react";

export function useFindItem(list = [], key, value) {
  return useMemo(() => {
    if (!list || !Array.isArray(list) || list.length === 0) {
      return null;
    }

    if (!key || value === undefined || value === null) {
      return null;
    }

    return list.find((item) => item[key] === value) || null;
  }, [list, key, value]);
}
